<template>
  <popup ref="popup" :loading="popupLoading">
    <div slot="body">
      <el-form
        class="dataForm"
        ref="form"
        :disabled="disabled"
        :model="formParameter"
        :inline="true"
        label-width="80px"
        :rules="rules"
      >
      
      <el-row>
          <el-col :span="8">
            <el-form-item  prop="name">
              {{parameter.name}}</el-form-item>
          </el-col>
      </el-row>
      <el-row>
          <el-col :span="24">
            <el-form-item label="进班" prop="addr">  
              <el-select v-model="formParameter.cid" placeholder="请选择">
                <el-option
                   v-for="v in clzess"
                   :key="v.id"
                   :label="v.name"
                   :value="v.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
       <el-row>
          <el-col :span="24">
            <el-form-item label="备注" prop="remark"
              ><el-input type="textarea"  rows="2"
                v-model="formParameter.remark"
                autocomplete="off"
              ></el-input
            ></el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div slot="footer">
      <el-button
        v-if="!disabled"
        type="primary"
        :loading="confirmLoading"
        @click="confirm()"
        >提 交</el-button
      >
      <el-button @click="close">取 消</el-button>
    </div>
  </popup>
</template>

<script>
import popup from "@/components/popup/drawerPopup.vue";
import api from "@/api/stu/stu.js";
import apiClz from "@/api/edu/clazz/clazz.js";

export default {
  name: "add2",
  components: {
    popup,
  },
  data() {
    return {
      disabled: false,
      popupLoading: false,
      confirmLoading: false,
      parameter: {},
      formParameter: {},
      me:{},
      rules: {},
      cwcnts:[],
      isShow:0,
      clzess:undefined
    };
  },
  methods: {
    //打开弹框
    open(parameter,me, type,title, disabled, size) {
      this.parameter = parameter;
      this.me = me
      this.disabled = disabled;
      this.$refs.popup.open(title, "45%");
      this.$nextTick(() => {
             apiClz.list3({},res=>{
                  this.clzess = res.data
               });
      });
    },
    //关闭弹框
    close() {
      this.disabled = false;
      this.formParameter =  {}
      this.$refs.popup.close();
    },
    //提交表单
    confirm() {
 
        this.confirmLoading = true;
        
            this.formParameter.id = this.parameter.id
            //进班
             api.jisou(
              this.formParameter,
               (response) => {
                this.$utils.msg.success(response.msg);
                this.confirmLoading = false;
                this.close();
                this.$parent.list();
            },
            (response) => {
              this.$utils.msg.warning(response.msg);
              this.confirmLoading = false;
             }
          );
    } 
  },
};
</script>

<style lang="scss" scoped="scoped">
@import "~common/custom/css/common.scss";
@import "~common/custom/css/popup/popup.scss";
</style>
